import * as React from 'react';
import { withBaseProps } from '@topconagriculture/react-components';
import { compose } from 'recompose';
import { Badge } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
const styles = (theme) => createStyles({
    popoverTriggerContainer: {
        position: 'relative',
        height: 45,
        '-webkit-touch-callout': 'none',
        '-webkit-user-select': 'none',
        '-khtml-user-select': 'none',
        '-moz-user-select': 'none',
        '-ms-user-select': 'none',
        'user-select': 'none',
    },
    popoverTrigger: {
        cursor: 'pointer',
        height: '40px',
        width: '40px',
        borderRadius: '100%',
        backgroundColor: theme.components.userMenu.colors.triggerBackground,
        color: theme.components.userMenu.colors.triggerText,
        top: '4px',
        textAlign: 'center',
        lineHeight: '40px',
        fontSize: '18px',
        fontWeight: theme.font.weight.bold,
        textTransform: 'uppercase',
    },
    badge: {
        position: 'absolute',
        top: 5,
        right: 3,
        transform: 'scale(0.8)'
    }
});
const UserMenuTrigger = (props) => {
    const { classes, handleOpen, user, badge } = props;
    return (React.createElement("div", { className: classes.popoverTriggerContainer },
        React.createElement("div", { className: classes.popoverTrigger, role: "button", onClick: handleOpen, "data-testid": 'user-menu-trigger' },
            user.firstName[0],
            user.lastName[0]),
        React.createElement(Badge, { color: "error", badgeContent: " ", invisible: !badge, className: classes.badge })));
};
export default compose(withBaseProps({ styles }))(UserMenuTrigger);
//# sourceMappingURL=UserMenuTrigger.js.map